import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useBasicLoginMutation } from '../../app/apiSlice';
import { useLazyProfileQuery } from "../../pages/users/profileSlice";
import { useLazyGetConfigQuery } from "../../app/apiSlice";
import { useTranslation } from "react-i18next";
import './authent.scss'

export const Basicauthent = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [basicLogin, { isLoading }] = useBasicLoginMutation();
  const navigate = useNavigate();
  const [triggerProfile] = useLazyProfileQuery();
  const [triggerConfig] = useLazyGetConfigQuery();
  const { t } = useTranslation();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      await basicLogin({ username, password }).unwrap();
      await triggerProfile();
      await triggerConfig();
      navigate("/");
    } catch (err) {
      setError(t("error.auth"));
      console.error(err);
    }
  };

  return (
    <div className="m-5 p-fluid auth-container">
      <h2>{t("title.authBasicPage")}</h2>
      <form onSubmit={handleLogin}>
        <div className="p-field m-2">
          <label htmlFor="username" className="labelauth block mb-2">{t("label.username")}</label>
          <InputText
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder={t("button.enter-id")}
            required
          />
        </div>

        <div className="p-field m-2">
          <label htmlFor="password" className="labelauth block mb-2">{t("label.password")}</label>
          <InputText
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("button.enter-pwd")}
            required
          />
        </div>

        {error && (
          <div className="p-error m-2">
            {error}
          </div>
        )}

        <Button
          label={isLoading ? t("message.connexion.ongoing") : t("button.connect")}
          icon="pi pi-sign-in"
          className="mt-3"
          type="submit"
          disabled={isLoading}
        />
      </form>
    </div>
  );
};